import React, { useState } from "react";
import PropTypes from "prop-types";
// import styles from "./styles/ConfirmModal.module.css";
import { Button, Modal } from "react-bootstrap";

const ConfirmModal = (props) => {
  const { onSubmit, children, title, body, submitButton, disabled, backdrop } =
    props;
  // state
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    if (disabled) return;
    setShow(true);
  };

  const handleSubmit = () => {
    onSubmit && onSubmit();
    handleClose();
  };
  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <>
      <span onClick={handleShow}>{children}</span>
      <Modal show={show} onHide={handleClose} backdrop={backdrop || true}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit}>{submitButton}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

/* required: display name */
ConfirmModal.displayName = "ConfirmModal";

/* required: props types */
ConfirmModal.propTypes = {
  disabled: PropTypes.bool,
};

/* required: default props */
ConfirmModal.defaultProps = { disabled: false };

export { ConfirmModal };
